import InputStyles from 'admin-components/styles/input';
import styled from 'styled-components';

const TextArea = styled.textarea.attrs(({ placeHolder }) => ({
  placeholder: placeHolder
}))`
  ${InputStyles};
`;

export default TextArea;
